"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _BaseSeoManagerEncoder = _interopRequireDefault(require("./BaseSeoManagerEncoder"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SeoManagerEncoderV1 = /*#__PURE__*/function (_BaseSeoManagerEncode) {
  _inherits(SeoManagerEncoderV1, _BaseSeoManagerEncode);

  var _super = _createSuper(SeoManagerEncoderV1);

  function SeoManagerEncoderV1(_this) {
    var _this2;

    _classCallCheck(this, SeoManagerEncoderV1);

    _this2 = _super.call(this, _this);
    _this2.domain = _this.domain;
    _this2.lang = _this.lang;
    _this2.supported_lang_slug = _this.supported_lang_slug;
    _this2.data = _this.data;
    _this2.num_levels = _this.num_levels;
    _this2.immotype = _this.immotype;
    _this2.encode_parts = _this.encode_parts;
    _this2.encode_qs = _this.encode_qs;
    return _this2;
  }

  _createClass(SeoManagerEncoderV1, [{
    key: "getLocalityParameters",
    value: function getLocalityParameters(loc) {
      var value = '';
      var parameters = '';
      var regionName = loc.parent && loc.parent.region && loc.parent.region.name || '';
      var provinceShort = loc.parent && loc.parent.province && loc.parent.province["short"] || '';
      var townName = loc.parent && loc.parent.town && loc.parent.town.name || '';
      var isFrance = loc.parent && loc.parent.region && (regionName === 'Provence-Alpes-Cote Azur' || regionName === 'Corsica');
      var loctype = loc && loc.type ? loc.type.toLowerCase() : null;

      switch (loctype) {
        case 'region':
          parameters = this.replaceAll(loc.name);
          break;

        case 'province':
          if (isFrance) {
            if (regionName === 'Provence-Alpes-Cote Azur') {
              parameters = "".concat(loc["short"], "%2c+").concat(this.replaceAll(regionName));
            } else {
              parameters = this.replaceAll(regionName);
            }
          } else {
            parameters = "".concat(loc["short"], "%2c+").concat(this.replaceAll(regionName));
          }

          break;

        case 'main_town':
          parameters = "".concat(this.findAndReplace(loc.name, ' ', '+'), "%2c+").concat(provinceShort, "%2c+").concat(this.replaceAll(regionName));
          break;

        case 'town':
          value = this.replaceAll(loc.name);
          parameters = "".concat(value, "%2c+").concat(provinceShort, "%2c+").concat(this.replaceAll(regionName));
          break;

        case 'area':
        case 'zone':
          value = this.replaceAll(loc.name);
          parameters = "".concat(value, "%2c+").concat(this.replaceAll(townName), "%2c+").concat(provinceShort, "%2c+").concat(this.replaceAll(regionName));
          break;

        case 'NOT_SPECIFIED':
          parameters = this.findAndReplace(loc.name, ' ', '+');
          break;

        case 'GEO_LOCATION':
          parameters = loc.coords;
          break;

        default:
          parameters = this.replaceAll(loc.name);
          break;
      }

      return parameters;
    }
  }, {
    key: "getPropertyTypology",
    value: function getPropertyTypology(filters) {
      var _this3 = this;

      var parameters = '';
      var flagTipologia = false;

      if (filters.propertyTypes.length > 0) {
        parameters = '/immobile-';
        var tipologia = filters.propertyTypes;
        tipologia.forEach(function (el, index) {
          var element = el;
          element = _this3.findAndReplace(element, ' ', '+');
          element = _this3.findAndReplace(element, '/', '+');
          element = _this3.findAndReplace(element, 'à', 'a');
          parameters += element;

          if (index < tipologia.length - 1) {
            parameters += '-';
          }
        });
        flagTipologia = true;
      } else {
        parameters += '/';
      }

      return [parameters, flagTipologia];
    }
  }, {
    key: "findAndReplace",
    value: function findAndReplace(str, find, replace) {
      if (!str) {
        return str;
      }

      if (Array.isArray(find)) {
        find.forEach(function (test, index) {
          str = str.replace(new RegExp(find[index], 'g'), replace[index]);
        });
      } else {
        str = str.replace(new RegExp(find, 'g'), replace);
      }

      return str;
    }
  }, {
    key: "replaceAll",
    value: function replaceAll(str) {
      if (!str) {
        return str;
      }

      str = str.replace(/ /g, '+').replace(/\//g, '%2f').replace(/'/g, '+').replace(/[àáâãäå]/gi, 'a').replace(/[èéêë]/gi, 'e').replace(/[òóôõö]/gi, 'o').replace(/[ìíîï]/gi, 'i').replace(/[ùúûü]/gi, 'u').replace(/’/g, '');
      return str;
    }
  }, {
    key: "createQS",
    value: function createQS(filters, isAreaSearch, isHome, voidString) {
      try {
        var urlsearch = '';
        var seller = '';
        var exteriorFeatures = [];
        var interiorFeatures = [];

        if ('level' in filters) {
          urlsearch += "&level=".concat(filters.level);
        }

        if (filters.lift) {
          if (filters.lift === true) {
            urlsearch += '&lift=true';
          } else {
            urlsearch += "&lift=".concat(filters.lift);
          }
        }

        if (filters.heating) {
          urlsearch += "&heatingType=".concat(filters.heating);
        }

        if ('heatingType' in filters) {
          if (!Array.isArray(filters.heatingType)) {
            filters.heatingType = [filters.heatingType];
          }

          urlsearch += "&heatingType=".concat(filters.heatingType.join(','));
        }

        if ('availability' in filters) {
          var value = filters.availability === 'nuda propr.' ? 'nuda proprietà' : filters.availability;
          urlsearch += "&availability=".concat(value);
        }

        if ('buildingCondition' in filters) {
          if (!Array.isArray(filters.buildingCondition)) {
            filters.buildingCondition = filters.buildingCondition.split(',');
          }

          urlsearch += "&buildingCondition=".concat(filters.buildingCondition.join(','));
        }

        var buildingYearMin = '';

        if ('buildingYearMin' in filters) {
          buildingYearMin = "min-".concat(filters.buildingYearMin);
        }

        var buildingYearMax = '';

        if ('buildingYearMax' in filters) {
          buildingYearMax = buildingYearMin === '' ? "max-".concat(filters.buildingYearMax) : ",max-".concat(filters.buildingYearMax);
        }

        if (buildingYearMin || buildingYearMax) {
          urlsearch += "&buildingYearRange=".concat(buildingYearMin).concat(buildingYearMax);
        }

        if ('energyClass' in filters) {
          urlsearch += "&energyClass=".concat(filters.energyClass);
        }

        var mqpriceMin = '';

        if ('mqpriceMin' in filters) {
          mqpriceMin = "min-".concat(filters.mqpriceMin);
        }

        var mqpriceMax = '';

        if ('mqpriceMax' in filters) {
          mqpriceMax = mqpriceMin === '' ? "max-".concat(filters.mqpriceMax) : ",max-".concat(filters.mqpriceMax);
        }

        if (mqpriceMin || mqpriceMax) {
          urlsearch += "&mqprice=".concat(mqpriceMin).concat(mqpriceMax);
        }

        var paymentMin = '';

        if ('paymentMin' in filters) {
          paymentMin = "min-".concat(filters.paymentMin);
        }

        var paymentMax = '';

        if ('paymentMax' in filters) {
          paymentMax = paymentMin === '' ? "max-".concat(filters.paymentMax) : ",max-".concat(filters.paymentMax);
        }

        if (paymentMin || paymentMax) {
          urlsearch += "&payment=".concat(paymentMin).concat(paymentMax, "&mortgage=").concat(filters.mortgage);
        }

        if ('geobounds' in filters && filters.geobounds !== undefined) {
          var gb = filters.geobounds;
          var bbox = JSON.stringify({
            bbox: [[gb[0], gb[3]], [gb[2], gb[1]]]
          });
          urlsearch += "".concat(urlsearch ? '&' : '?', "geobounds=").concat(bbox);
        }

        if ('geocircle' in filters && filters.geocircle !== undefined) {
          var geoc = filters.geocircle;
          var geocircle = JSON.stringify({
            circle: [{
              center: geoc.center,
              distance: geoc.radius
            }]
          });
          urlsearch += "".concat(urlsearch ? '&' : '?', "geocircle=").concat(geocircle);
        }

        if ('geopolygon' in filters && filters.geopolygon !== undefined) {
          var geop = filters.geopolygon;
          var polygon = [];

          if (Array.isArray(geop)) {
            geop.map(function (p) {
              return polygon.push([p[1], p[0]]);
            });
            var geopolygon = JSON.stringify({
              polygon: polygon
            });
            urlsearch += "".concat(urlsearch ? '&' : '?', "geopolygon=").concat(geopolygon);
          }
        }

        if ('q' in filters && filters.q !== undefined && filters.q !== '0') {
          var q = filters.q;
          urlsearch += "".concat(urlsearch ? '&' : '?', "q=").concat(q);
        }

        if ('precision' in filters && !filters.precision && filters.precision !== 'undefined' && filters.precision !== undefined) {
          var precision = filters.precision;
          urlsearch += "".concat(urlsearch ? '&' : '?', "precision=").concat(precision);
        }

        if ('pId' in filters && filters.pId && filters.pId !== '0') {
          var pId = filters.pId;
          urlsearch += "&pId=".concat(pId);
        }

        if (filters.numRooms) {
          urlsearch += "&numRooms=".concat(filters.numRooms);
        }

        if (filters.numBaths) {
          urlsearch += "&numBaths=".concat(filters.numBaths);
        }

        if (filters.numParkingSpaces) {
          urlsearch += "&numParkingSpaces=".concat(filters.numParkingSpaces);
        }

        if (filters.sellerType) {
          if (!Array.isArray(filters.sellerType)) {
            filters.sellerType = [filters.sellerType];
          }

          if (filters.sellerType[0]) {
            filters.sellerType.forEach(function (el, index) {
              seller += el.toLowerCase();

              if (index < filters.sellerType.length - 1) {
                seller += ',';
              }
            });
            urlsearch += "&sellerType=".concat(seller);
          }
        }

        if (filters.photo === true) {
          urlsearch += '&misc=photo-only';
        }

        if (filters.garden) {
          exteriorFeatures.push("giardino-".concat(filters.garden));
        }

        if (filters.balcony === true) {
          exteriorFeatures.push('balcone');
        }

        if (filters.terrace === true) {
          exteriorFeatures.push('terrazzo');
        }

        if (exteriorFeatures.length > 0) {
          urlsearch += '&exteriorFeatures=';

          for (var i = 0; i < exteriorFeatures.length; i++) {
            urlsearch += exteriorFeatures[i];
            if (i < exteriorFeatures.length - 1) urlsearch += ',';
          }
        }

        if (interiorFeatures.length > 0) {
          urlsearch += '&interiorFeatures=';

          for (var _i = 0; _i < interiorFeatures.length; _i++) {
            urlsearch += interiorFeatures[_i];
            if (_i < interiorFeatures.length - 1) urlsearch += ',';
          }
        }

        if (filters.zone && filters.zone[0]) {
          filters.zones = filters.zone;
        }

        if (filters.zones && filters.zones[0]) {
          urlsearch += '&zone=';

          if (!Array.isArray(filters.zones)) {
            filters.zones = filters.zones.split('|');
          }

          filters.zones.forEach(function (el, index) {
            urlsearch += el;

            if (index < filters.zones.length - 1) {
              urlsearch += ',';
            }
          });
        } else if (filters.surrounding === true || filters.surrounding === 'true' || filters.includeSurrounding === true || filters.includeSurrounding === 'true') {
          urlsearch += '&includeSurrounding=true';
        }

        return urlsearch;
      } catch (err) {
        console.error("createQS error: ".concat(err));
        return '';
      }
    }
  }, {
    key: "encodeSeoUrl",
    value: function encodeSeoUrl(params, locations) {
      var _this4 = this;

      var qs = Object.assign({}, params);
      ['tr', 'category', 'propertyTypes', 'mqMin', 'mqMax', 'priceMin', 'priceMax', 'locations', 'detailAgencyId', 'sortType', 'page', 'zone', 'numRooms', 'numBaths', 'numParkingSpaces', 'level', 'lift', 'heatingType', 'garden', 'energyClass', 'buildingYearMin', 'buildingYearMax', 'availability', 'photo', 'misc', 'terrace', 'balcony', 'sellerType', 'buildingCondition', 'activeSort', 'pId', 'paymentMin', 'paymentMax', 'mortgage', 'mqpriceMin', 'mqpriceMax', 'publisherId', 'price', 'surrounding', 'includeSurrounding', 'zone', 'zones', 'isRoomsNumber', 'q'].map(function (key) {
        return delete qs[key];
      });

      if (qs.wrongPropertyTypes) {
        if (Array.isArray(qs.wrongPropertyTypes) && qs.wrongPropertyTypes.length >= 0 && qs.wrongPropertyTypes[0] === 'nuova+costruzione') {
          qs.buildingCondition = ['nuovo'];
        }

        delete qs.wrongPropertyTypes;
      }

      var paramsPath = '';
      var parameters = '';
      var urlsearch = '';
      var url = '';
      var isAreaSearch = false;
      var flagTipologia = false;
      var TR = {
        vendite: 'vendita',
        vendita: 'vendita',
        affitto: 'affitto',
        affitti: 'affitto'
      };

      if ('tr' in params && TR[params.tr]) {
        params.tr = TR[params.tr];
      }

      paramsPath = "/".concat(params.tr, "-");
      paramsPath += params.category ? "".concat(params.category, "/") : 'residenziale/'; // property typology

      if (params.propertyTypes) {
        if (!Array.isArray(params.propertyTypes)) {
          params.propertyTypes = params.propertyTypes.split();
        }

        if (params.propertyTypes.length > 0) {
          parameters += this.getPropertyTypology(params)[0];
          flagTipologia = this.getPropertyTypology(params)[1];
        }
      } // property size range


      if (params.mqMin || params.mqMax) {
        parameters += flagTipologia ? '-dimensione-' : 'dimensione-';
        parameters += params.mqMin ? "".concat(params.mqMin.replace(/\./g, ''), "-") : '0-';
        parameters += params.mqMax ? params.mqMax.replace(/\./g, '') : 'qualsiasi';
      } // property price range


      if (params.priceMin || params.priceMax) {
        parameters += params.mqMin || params.mqMax || flagTipologia ? '-per-' : 'per-';
        parameters += params.priceMin ? "".concat(params.priceMin.replace(/\./g, ''), "-") : '0-';
        parameters += params.priceMax ? params.priceMax.replace(/\./g, '') : 'qualsiasi';
      } // localities


      if (locations && Array.isArray(locations) && locations.length > 0) {
        if (flagTipologia || params.priceMin && params.priceMin !== '0' || params.priceMax && params.priceMax !== 'qualsiasi' || params.mqMin && params.mqMin !== '0' || params.mqMax && params.mqMax !== 'qualsiasi') {
          parameters += '-in-';
        } else {
          parameters += 'in-';
        }
      }

      if (locations && Array.isArray(locations)) {
        locations.forEach(function (loc, index) {
          if (loc.level !== 999) {
            var loctype = loc && loc.type ? loc.type.toLowerCase() : null;

            if (loctype === 'area') {
              isAreaSearch = true;
            }

            parameters += _this4.getLocalityParameters(loc);

            if (index < locations.length - 1) {
              parameters += '%3b';
            }

            if (!isNaN(loc.name) && loc.name.length > 5 && loc.type !== 'freetext' && loc.type !== 'postalcode') {
              isAPdpCode = true;
              pdpCode = loc.name;
            }
          }
        });
      } // is this an agency SRP listing?


      var publisherId = params.detailAgencyId || params.pId || null;

      if (publisherId) {
        delete params.pId;

        if (locations.length > 0 || flagTipologia || params.priceMin !== 'all' && params.priceMin !== '0' && params.priceMin !== undefined || params.priceMax !== 'all' && params.priceMax !== 'qualsiasi' && params.priceMax !== undefined || params.mqMin !== 'all' && params.mqMin !== '0' && params.mqMin !== undefined || params.mqMax !== 'all' && params.mqMax !== 'qualsiasi' && params.mqMax !== undefined) {
          parameters += '-da-' + publisherId;
        } else {
          parameters += 'da-' + publisherId;
        }
      }

      if (params.sortType && params.sortType !== 'relevance') {
        if (params.sortType.split(/_/g)[0] === 'new') {
          params.sortType = params.sortType.replace(/new_/g, 'date_');
        }

        urlsearch += "?activeSort=".concat(params.sortType);
      } else {
        urlsearch += '?';
      }

      urlsearch += this.createQS(params, isAreaSearch, false, urlsearch === '');
      urlsearch = urlsearch.replace(/\?&/g, '?');
      urlsearch = urlsearch.replace(/&&/g, '&');
      urlsearch = urlsearch.replace(/\?\?/g, '?');
      urlsearch = urlsearch !== '?' ? urlsearch : '';

      var getPage = function getPage() {
        return 'page' in params && params.page ? params.page : 1;
      };

      url = "".concat("".concat(paramsPath).concat(parameters, "/lista-").concat(getPage()).toLowerCase()).concat(urlsearch);
      url = this.findAndReplace(url, '//', '/');
      url = this.findAndReplace(url, ';;', ';');
      url = this.findAndReplace(url, ';/', '/');
      url = url[url.length - 1] === ',' ? url.slice(0, -1) : url;

      if (Object.keys(qs).length > 0) {
        var final_qs = this.getQS(qs).replace(/\?/gi, '');

        if (final_qs.trim().length > 0) {
          url += '' + (url.indexOf('?') > -1 ? '&' : '?') + final_qs;
        }
      }

      if (url.slice(-1) === '?') {
        url = url.replace(/\?/g, '');
      }

      url = url.replace(/%2c/g, '%2C').replace(/%2f/g, '%2F');
      return url;
    }
  }, {
    key: "encodeHrefLang",
    value: function encodeHrefLang(params) {
      var _this5 = this;

      var locations = params.locations;
      var href_lang = {};
      var ret = {};
      this.supported_lang_slug.map(function (l) {
        _this5.lang = l;
        params.tr = _this5.getTREncode()[_this5.lang][params.tr] || 'vendita';
        href_lang[l] = _this5.finalUrlToLangUrl(_this5.encodeSeoUrl(params, locations)).split(/[?#]/)[0];
      });
      ret.canonical = href_lang[this.lang];
      ret.hreflang = href_lang;
      ret.seo = ret.canonical;

      if ('listingId' in params) {
        ret.pdp = this.encodePdpUrl(params);
      } else {
        ret.srp = this.encodeSrpUrl(params, locations);
        ret.srpMap = this.encodeSrpUrl(Object.assign({}, params, {
          isMap: true
        }), locations);
      }

      return ret;
    }
  }, {
    key: "encode",
    value: function encode(params) {
      var locations = params.locations;
      var final_url;
      var forceSrp = params.forceSrp || false;
      delete params.forceSrp;

      if (forceSrp) {
        final_url = this.encodeSrpUrl(params, locations);
      } else if ('listingId' in params) {
        final_url = this.encodePdpUrl(params, locations);
      } else {
        final_url = this.encodeSeoUrl(params, locations);
      }

      return this.finalUrlToLangUrl(final_url);
    }
  }]);

  return SeoManagerEncoderV1;
}(_BaseSeoManagerEncoder["default"]);

var _default = SeoManagerEncoderV1;
exports["default"] = _default;